import React, { useState, useEffect, useContext } from 'react';
import { distitoMateraAPI, apiURL } from '../../Util/apiURL';
import AuthContext from '../../store/auth-context';
import {
  createPagoClienteActions,
  insertPagoCliente,
} from '../../store/crearPagoCliente-slice';
import { useSelector, useDispatch } from 'react-redux';
import { Column } from '../SharedUi/Grid';
import { CardButton } from '../SharedUi/UpdateCardUI';
import SelectHelper from '../TailwindUI/SelectHelper';
import { TextInput } from '../Clientes/CreateCliente';
import SelectDate from '../SharedUi/SelectDate';
import { InputCornerHint } from '../SharedUi/Inputs';
import IconButton from '../TailwindUI/IconButton';
import SuccesAlert from '../SuccesAlert/SuccesAlert';

const CreatePagoFromCpc = (props) => {
  const authCtx = useContext(AuthContext);
  const dispatch = useDispatch();

  useEffect(() => {
    let firstTime = 0;
    if (firstTime === 0 && props.divisa.id === 1) {
      let payload = {
        reduxStateTree: 'divisa',
        valuesToFilter: [props?.divisa],
        selectedValue: props?.divisa?.id,
      };

      dispatch(createPagoClienteActions.asign(payload));
    }
    firstTime++;
  }, []);

  //#region Redux Selectors--------------------------------->
  const createPagoCliente = useSelector((state) => state.createPagoCliente);
  const fecha = useSelector((state) => state.createPagoCliente.fecha);
  const observaciones = useSelector(
    (state) => state.createPagoCliente.observaciones
  );

  //#endregion  Redux Selectors <---------------------------------
  //#region  DiableSumbit Button

  let disableSubmit = true;
  if (createPagoCliente?.monto && fecha && createPagoCliente?.divisa?.id) {
    disableSubmit = false;
  }
  //#endregion

  //#region Function Handlers--------------------------------->

  const handleAsingDivisa = (e) => {
    dispatch(createPagoClienteActions.asign({ ...e }));
    dispatch(createPagoClienteActions.resetMonto());
  };

  const handleCreatePago = () => {
    console.log('create  pago proveedor ');
    let request = {
      cuenta_por_cobrar_id: createPagoCliente.cpp.id,
      monto: createPagoCliente.monto.toFixed(2),
      observaciones: createPagoCliente.observaciones,
      fecha: createPagoCliente.fecha,
      divisa_id: createPagoCliente.divisa?.id,
      tipo_de_cambio: createPagoCliente?.tipoDeCambio.toFixed(4),
    };
    console.log(request);
    dispatch(
      insertPagoCliente({
        request,
      })
    );
    // props.onConfirm();
  };

  const handleDate = (e) => {
    dispatch(
      createPagoClienteActions.change({
        field: 'fecha',
        value: e.target.value,
      })
    );
  };

  const handleMonto = (e) => {
    const divisaPeso = props.divisa?.id === 1;
    const divisaDolar = props.divisa?.id === 2;
    const montoValue = Number(e.target.value);
    const montoYTipoDeCambioValue =
      Number(e.target.value) / createPagoCliente?.tipoDeCambio;
    const sumaPagosYnotaYMonto = montoValue + props.totalPagosYNotas;
    const sumaPagosYnotaYMontoYtipoDeCambio =
      montoYTipoDeCambioValue + props.totalPagosYNotas;
    const condition1 =
      props.totalPagosYNotas === 0 && montoValue <= props.totalCpc;
    const condition2 = sumaPagosYnotaYMonto <= props.totalCpc;
    const condition1TipoDeCambio =
      props.totalPagosYNotas === 0 && montoYTipoDeCambioValue <= props.totalCpc;

    const condition2TipoDeCambio =
      sumaPagosYnotaYMontoYtipoDeCambio <= props.totalCpc;
    const dispatchMonto = () => {
      dispatch(
        createPagoClienteActions.change({
          field: 'monto',
          value: e.target.value,
        })
      );
      return;
    };

    if (e.target.value > 0) {
      if (divisaPeso || (divisaDolar && createPagoCliente.divisa.id === 2)) {
        if (condition1 || condition2) {
          dispatchMonto();
          return;
        }
        return;
      }
      if (divisaDolar && createPagoCliente.divisa.id === 1) {
        if (condition1TipoDeCambio || condition2TipoDeCambio) {
          dispatchMonto();

          return;
        }
        return;
      }
      return;
    }
  };
  //#endregion Function Handler <---------------------------------

  return (
    <div className="flex flex-col">
      {/* {JSON.stringify(createPagoCliente)} */}

      <>
        {props?.divisa?.id === 2 ? (
          <SelectHelper
            //UI
            label={'Divisa'}
            inputLabel={'SeleccionarDivisa'}
            //URL
            fetchUrl={'divisas'}
            //Redux
            asignTree={'divisa'}
            removeTree={'divisa'}
            valueToAsignSelector={createPagoCliente.divisa}
            // asignedListString={'relationsProductos'}
            //Select Options
            nameOfPropertyToAsign={'nombre'}
            //Function Handlers
            handleSelect={handleAsingDivisa}
          />
        ) : (
          <InputCornerHint
            label={'Divisa'}
            type={'text'}
            value={createPagoCliente?.divisa?.nombre}
            disbaled
          />
        )}

        <div className="mt-1" />
        {props?.divisa?.id === 2 &&
          createPagoCliente?.divisa?.nombre === 'MXN' && (
            <InputCornerHint
              label={'Tipo de Cambio'}
              type={'number'}
              value={createPagoCliente.tipoDeCambio}
              onChange={(e) => {
                dispatch(
                  createPagoClienteActions.change({
                    value: e.target.value,
                    field: 'tipoDeCambio',
                  })
                );
              }}
            />
          )}
        <div className="mt-6" />
        {createPagoCliente.divisa?.id && (
          <InputCornerHint
            label={'Monto'}
            type={'number'}
            value={createPagoCliente.monto}
            onChange={handleMonto}
          >
            <button
              onClick={() => {
                console.log('dispatch saldo pendiente');
                const divisaDolar = props?.divisa?.id === 2;
                const divisaPeso = props?.divisa?.id === 1;

                const restante =
                  Number(props.totalCpc) - Number(props.totalPagosYNotas);
                const restanteContipoDeCambio =
                  restante * createPagoCliente?.tipoDeCambio;

                if (divisaDolar) {
                  dispatch(
                    createPagoClienteActions.change({
                      field: 'monto',
                      value:
                        props?.divisa?.id === 2 &&
                        createPagoCliente?.divisa?.nombre === 'MXN'
                          ? restanteContipoDeCambio.toFixed(2)
                          : restante.toFixed(2),
                    })
                  );
                }
                if (divisaPeso) {
                  dispatch(
                    createPagoClienteActions.change({
                      field: 'monto',
                      value: restante.toFixed(2),
                    })
                  );
                }
              }}
            >
              <span className="px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800">
                Saldo Pendiente
              </span>
            </button>
          </InputCornerHint>
        )}
        <div className="mt-1" />
        <SelectDate reduxStateTree={'fecha'} action={handleDate}>
          <InputCornerHint
            value={createPagoCliente?.fechaDisplay}
            disabled
            label={'Fecha del Pago'}
          />
        </SelectDate>
        <div className="mt-2" />
        <InputCornerHint
          label={'Observaciones'}
          type={'text'}
          value={createPagoCliente?.observaciones}
          onChange={(e) => {
            dispatch(
              createPagoClienteActions.change({
                value: e.target.value,
                field: 'observaciones',
              })
            );
          }}
        />
      </>
      {createPagoCliente.closeModal ? (
        <div className="mt-4">
          <SuccesAlert
            message={'Tu Pago se registro con éxito'}
            onClick={() => {
              props.onConfirm();
              dispatch(createPagoClienteActions.resetCloseModal());
            }}
          />
        </div>
      ) : (
        <CardButton disabled={disableSubmit} onClick={handleCreatePago}>
          Registrar Pago
        </CardButton>
      )}
    </div>
  );
};
export default CreatePagoFromCpc;
